import { Injectable } from "@angular/core";
import { DwAction, DwActionHandler, DwActionResult, DwActionType, DwButtonType, DwGridActionConfig, DwMetaDataGridActionState, DwRoutingService } from "@devwareapps/devware-cap";
import { Observable, of } from "rxjs";
import { AppMetaDataItemNames, RoAssessmentAcsMissedCodeFactEntity } from "../../../meta-data/app-meta-data.service";
import { PilexosUserTypeIds } from "../../shared/models/pilexos-user-type.enum";
import { AdminManagerService } from "../../shared/services/admin-manager.service";

@DwAction<DwGridActionConfig>({
    keyName: 'ro-assessment-acs-missed-code-fact-open',
    display: 'Open Assessment',
    actionType: DwActionType.gridRowAction,
    parentItemName: AppMetaDataItemNames.RoAssessmentAcsMissedCodeFact,
    isGlobal: false,
    allowOnce: true,
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: '',
        buttonClass: 'btn btn-primary btn-sm',
        buttonTitle: 'Open related assessment',
        buttonType: DwButtonType.iconOnlyNoText,
        iconClass: 'dw-icon-grid fa fa-external-link-alt',
        command: 'open'
    }
})
@Injectable()
export class RoAssessmentAcsMissedCodeFactOpenActionService implements DwActionHandler {

    constructor(
        private dwRoutingService: DwRoutingService,
        private adminManagerService: AdminManagerService
    ) { }

    handleAction(actionState: DwMetaDataGridActionState<any>): Observable<DwActionResult> {
        const result = new DwActionResult();
        const row = this.getRow(actionState);
        const url = this.getUrl(row);

        if (!url) {
            result.success = false;
            result.cancelled = true;
            result.message = 'Unable to determine the destination for this assessment record.';
            result.hideMessage = false;
            return of(result);
        }

        this.dwRoutingService.navigateToUrl(url, actionState.dwBrowserEvent as any);

        result.success = true;
        return of(result);
    }

    private getRow(actionState: DwMetaDataGridActionState<any>): RoAssessmentAcsMissedCodeFactEntity | null {
        return (actionState.selectedItem || actionState.data) as RoAssessmentAcsMissedCodeFactEntity || null;
    }

    private getUrl(row: RoAssessmentAcsMissedCodeFactEntity | null): string | null {
        if (!row) {
            return null;
        }

        if (row.SourceType === 'POA' && row.PlanOfActionId) {
            return `/plan-of-action/plans/edit/${row.PlanOfActionId}`;
        }

        if (row.SourceType !== 'CR' || !row.CheckRideRequestId) {
            return null;
        }

        const pilexosUser = this.adminManagerService.getPilexosUser();

        if (pilexosUser?.UserTypeId === PilexosUserTypeIds.pilotExaminer) {
            return `/bookings/edit/${row.CheckRideRequestId}`;
        }

        const schoolUserTypes = [
            PilexosUserTypeIds.flightSchool,
            PilexosUserTypeIds.checkInstructor,
            PilexosUserTypeIds.flightInstructor
        ];

        if (schoolUserTypes.includes(pilexosUser?.UserTypeId)) {
            return `/school-checkrides/edit/${row.CheckRideRequestId}`;
        }

        return null;
    }
}
